import { WarningOutlined } from '@ant-design/icons';
import { Card, Typography } from 'antd';
import { memo } from 'react';

import { generateSpanWithDataTestId } from '@app/shared/utils';

import type { FC } from 'react';

const { Text } = Typography;

interface ImportErrorItemProps {
  row: number;
  error: string;
}

const ImportErrorItemCard: FC<ImportErrorItemProps> = ({ row, error }) => (
  <Card className="list-item" data-testid="error-item">
    <WarningOutlined style={{ color: '#f26905' }} />
    <Text strong data-testid="error-row">
      {' '}
      Ряд {`${row} `}
    </Text>
    {generateSpanWithDataTestId(error, 'error-description')}
  </Card>
);

// memo: каждое событие прогресса приносит полный список ошибок, и без него
// на больших файлах перерисовываются сотни карточек на каждое событие.
export const ImportErrorItem = memo(ImportErrorItemCard);
